var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99943 7.80355C8.63109 7.80355 7.49943 8.93605 7.49943 10.3035C7.49943 11.6719 8.63109 12.8035 9.99943 12.8035C11.3669 12.8035 12.4994 11.6719 12.4994 10.3035C12.4994 8.93605 11.3669 7.80355 9.99943 7.80355Z",
    fill: "#374B5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99943 4.47021C3.63859 4.47021 1.72693 9.98438 1.70943 10.0402L1.62109 10.3035L1.70859 10.5669C1.72693 10.6227 3.63859 16.1369 9.99943 16.1369C16.3603 16.1369 18.2719 10.6227 18.2894 10.5669L18.3778 10.3035L18.2903 10.0402C18.2719 9.98438 16.3603 4.47021 9.99943 4.47021ZM9.99943 14.4702C5.54026 14.4702 3.81276 11.2652 3.39443 10.3035C3.81443 9.33855 5.54276 6.13688 9.99943 6.13688C14.4586 6.13688 16.1861 9.34188 16.6044 10.3035C16.1844 11.2685 14.4561 14.4702 9.99943 14.4702Z",
    fill: "#374B5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6f4e1a8bdab7b0bc45582e7dab9e2624.svg";
export { ForwardRef as ReactComponent };